import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "d-flex justify-content-end" }
const _hoisted_3 = { class: "p-3 fw-bold" }
const _hoisted_4 = {
  class: "row mx-1 dashbord-list",
  style: {"height":"95%"}
}
const _hoisted_5 = { class: "d-flex justify-content-end m-3" }

import 'gitart-vue-dialog/dist/style.css'
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DriversWithPotentiallyExcessiveHoursDetailModal',
  props: {
    modelValue: { type: Boolean },
    start_date: {},
    end_date: {},
    details: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const month = computed(() => {
  return new Date(props.end_date).getMonth() + 1
})

const convertSecondsToHHmm = computed(() => (seconds: number) => {
  let hour = Math.floor(seconds / 3600);
  let minutes: string | number = Math.floor(seconds % 3600 / 60);
  if (minutes < 10) minutes = '0' + minutes;

  return (hour + ':' + minutes);
})

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(InfoModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    title: _unref(i18n).global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.title'),
    modalHeight: "80%",
    slotTextAreaHeight: "60%"
  }, {
    text: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("small", _hoisted_3, _toDisplayString(`${month.value} ${_unref(i18n).global.t('pages.dashboard.monthly')} (${__props.start_date} ~ ${__props.end_date}) ${_unref(i18n).global.t('pages.dashboard.displayData')}`), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, { class: "h-100 px-0" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.driverName')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.driverId')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.restraint')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.predictionRestraintTime')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (__props.details?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.details, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.driver_id,
                        style: _normalizeStyle('background-color:' + item?.restraint_over_threshold_background_color ),
                        class: _normalizeClass(item?.restraint_over_threshold_background_color ? 'overThresholdRow' : '')
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.last_name) + " " + _toDisplayString(item.first_name), 1),
                        _createElementVNode("td", null, _toDisplayString(item.driver_id), 1),
                        _createElementVNode("td", null, _toDisplayString(convertSecondsToHHmm.value(item.restraint)), 1),
                        _createElementVNode("td", {
                          style: _normalizeStyle(`color: ${item?.prediction_restraint_color}`)
                        }, _toDisplayString(convertSecondsToHHmm.value(item.prediction_restraint_time)), 5)
                      ], 6))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          class: "m-1 reset-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.closeBtn')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})